import "../App.css";
import { Outlet, useParams } from "react-router-dom";
import { useInfo } from "../hooks/useData";
import Layout from "./Layout";
import Spinner from "./Spinner";
import useClient from "../hooks/clientStore";
import { useEffect } from "react";
import { getClient } from "src/services/client";
import { Delta } from "quill";

function ClientContainer() {
  // const { id } = useParams();

  // const fetchData = () => {
  //   console.log("fetchData");
  //   return getClient(id)
  //     .then((data) => data.json())
  //     .then((data) => {
  //       setData(data);
  //       data = { ...data.data, scenarios: data.scenarios };
  //     });
  // };
  // useEffect(() => {
  //   fetchData();
  // }, []);

  // const [data, setData] = useState<Client | null>(null);
  const { data: clientData, setLocal: updateClientData } = useInfo();
  const { id } = useParams();

  const setNotes = useClient((state) => state.setNotes);
  useEffect(() => {
    if (id && (!clientData || clientData.id?.toString() !== id)) {
      getClient(id)
        .then((data) => data.json())
        .then((data) => {
          let newData = { ...data };
          setNotes(new Delta(data.notes));
          updateClientData(newData);
        });
    }
  }, [id, clientData, updateClientData]);

  if (!clientData || clientData.id?.toString() !== id) {
    return (
      <Layout page="">
        <Spinner />
      </Layout>
    );
  }

  return <Outlet />;
}

export default ClientContainer;
